import styled from "styled-components"
import { MainColumn } from "components/MainColumn"
import { device } from "../../utils/breakpoints.js"
export const ContactPageContainer = styled(MainColumn)`
  /* padding-bottom:40px; */

  > div {
    margin-bottom: 0;
  }

  @media ${device.desktop} {
    padding-bottom: 120px;
  }
`
